import { useDispatch, useSelector } from 'react-redux';
import { useEffect } from 'react';

import { IBoardSlim, PARSAction } from 'core/models';
import { getAllBoards } from 'store/board/actions';
import { boardSelector } from 'store/board/selectors';
import { ThunkDispatch } from 'redux-thunk';
import { AppState } from 'store';

export const useBoardList = (): IBoardSlim[] => {
  const boards: IBoardSlim[] = useSelector(boardSelector);
  const dispatch: ThunkDispatch<AppState, unknown, PARSAction> = useDispatch();

  useEffect(() => {
    if (!boards) {
      dispatch(getAllBoards());
    }
  }, []);

  return boards;
};
